import React, { PropTypes } from "react";
import { NavItem } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const ConfigurationsButton = (props) => {
  return (
    <NavItem eventKey="2" onClick={props.onClickHandler}>
      <span className="icon icon-cog" />
      <FormattedMessage id="configurationsForm.configurations" />
    </NavItem>
  );
};

ConfigurationsButton.propTypes = {
  onClickHandler: PropTypes.func.isRequired,
};

export default ConfigurationsButton;



// WEBPACK FOOTER //
// ./src/components/common/Configurations/ConfigurationsButton.js